import React, { useState, useEffect, useContext } from 'react';
import { Grid, Stack, Avatar, IconButton, Typography, Button, Paper, Card, Box, CardContent, Popper, CardMedia } from '@mui/material';
import { ExpandMore, Adb, ExpandLess, ChevronLeft, ChevronRight } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';
import MainCard from 'ui-component/cards/MainCard';
import LoginContext from 'Context/ContextLogin';
import { ReactComponent as IconUser } from 'assets/images/icons/avatar-sin-foto.svg';
import { useTheme } from '@mui/material/styles';
import Calendario from './Calendario';
import Contacto from '../ComponentsHomeVentas/Contacto';
import 'react-multi-carousel/lib/styles.css';
import Services from 'utils/serviciosVentas';
import { ModalGeneral } from 'ui-component';
import moment from 'moment';
import 'moment/locale/es';
import ItemCarousel from './ItemCarousel';
import FloatingOverlay from 'views/components/floatingOverlay/FloatingOverlay';
import NotificacionesCarousel from './NotificacionesCarousel';
import FiltrosEstadoCursos from 'views/components/cursos/FiltroEstadoCursos';

const useStyle = makeStyles((theme) => ({
    principal: {
        position: 'relative',
        width: '100%'
    },
    notificaciones: {
        position: 'fixed',
        right: '30px',
        bottom: '180px',
        zIndex: 1000
    },
    root: {
        minWidth: '100%',
        backgroundColor: '#E0E0E0',
        marginRight: '20px',
        '&:hover': {
            cursor: 'pointer'
        }
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)'
    },
    title: {
        fontSize: 14
    },
    pos: {
        marginBottom: 12
    },
    btnCancelar: {
        color: theme.palette.btn.red,
        '&:hover': {
            backgroundColor: theme.palette.btn.red,
            color: theme.palette.btn.white
        }
    }
}));

// Función para calcular el n-ésimo día específico de un mes
// Por ejemplo: primer lunes de febrero, tercer lunes de marzo
function calcularNesimoDia(year, month, dayOfWeek, occurrence) {
    const firstDay = moment(`${year}-${month}-01`);
    const firstOccurrence = firstDay.clone().day(dayOfWeek);

    // Si el primer día del mes es después del día buscado, avanzar a la siguiente semana
    if (firstOccurrence.month() !== month - 1) {
        firstOccurrence.add(7, 'days');
    }

    // Agregar las semanas necesarias para llegar a la n-ésima ocurrencia
    firstOccurrence.add((occurrence - 1) * 7, 'days');

    return firstOccurrence.format('YYYY-MM-DD');
}

// Genera eventos de festivos basados en la configuración del backend
const generarEventosFestivos = (configuracionFestivos) => {
    const yearActual = moment().year();
    const yearInicio = yearActual - 5;
    const yearFin = yearActual + 10;
    const festivos = [];

    for (let year = yearInicio; year <= yearFin; year++) {
        configuracionFestivos.forEach((config) => {
            let fecha = null;

            if (config.tipo === 'nesimo') {
                // Calcular n-ésimo día (ej: primer lunes de febrero)
                fecha = calcularNesimoDia(year, config.mes, config.diaSemana, config.ocurrencia);
            } else if (config.tipo === 'periodico') {
                // Solo si el año corresponde al periodo (ej: cada 6 años)
                if ((year - config.yearBase) % config.periodo === 0) {
                    fecha = `${year}-${String(config.mes).padStart(2, '0')}-${String(config.dia).padStart(2, '0')}`;
                }
            } else {
                // Fecha fija (ej: 1 de enero)
                fecha = `${year}-${String(config.mes).padStart(2, '0')}-${String(config.dia).padStart(2, '0')}`;
            }

            if (fecha) {
                festivos.push({
                    id: `festivo-${config.titulo}-${year}`,
                    date: fecha,
                    title: config.titulo,
                    desc: config.motivo,
                    tipo: 'festivo',
                    oficial: config.oficial
                });
            }
        });
    }

    return festivos;
};

const ItemNumero = ({ color, num, msj, selected, onClick }) => {
    return (
        <Button
            variant={selected ? 'contained' : 'outlined'}
            sx={{
                width: '100%',
                backgroundColor: selected ? color : undefined,
                color: selected ? '#fff' : undefined,
                borderColor: color,
                mb: 1,
                fontWeight: 600,
                boxShadow: selected ? 2 : 0
            }}
            onClick={onClick}
        >
            <Stack direction="column" alignItems="center">
                <Typography variant="h3" gutterBottom>
                    {num}
                </Typography>
                <Typography variant="body2" component="p">
                    {msj}
                </Typography>
            </Stack>
        </Button>
    );
};

const InicioV2 = (props) => {
    const { usuario, selectCurso, setCargando, option, esIncognito } = props;
    const services = Services();
    const classes = useStyle();
    const theme = useTheme();
    const context = useContext(LoginContext);
    const [cursos, setCursos] = useState([]);
    const [avisos, setAvisos] = useState([]);
    const [notificaciones, setNotificaciones] = useState([]); // Para la burbuja flotante
    const [notificacionesSlide, setNotificacionesSlide] = useState([]);
    const [cursoFiltro, setCursoFiltro] = useState(null);
    const [modal, setModal] = useState({ open: false, props: null, componente: null });
    const [anchorEl, setAnchorEl] = React.useState(null);

    const cerrarModal = () => {
        setModal({
            ...modal,
            open: false
        });
    };

    const abrirMensajeCalendario = (data) => {
        const fe = moment(data.fecha).locale('es').format('DD-MMMM-YYYY');
        setModal({
            open: true,
            titulo: 'Actividad programada',
            mensaje: `${fe} - ${data.titulo}`
        });
    };

    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;

    useEffect(() => {
        if (usuario && usuario != null) {
            setCargando({ open: true });
            const idcrm = usuario.idCRM ? usuario.idCRM : null;
            services.buscaCursosColab(
                (data) => {
                    setCargando({ open: false });

                    // SEPARAR CURSOS Y NOTIFICACIONES
                    let listaCursos = [];
                    let listaNotificacionesSlide = []; // Solo notificaciones slide
                    let arr = [];
                    let noti = []; // Solo notificaciones NO slide

                    // Procesar cursos
                    data?.cursos.forEach((cur) => {
                        listaCursos.push(cur);

                        arr.push({
                            id: cur.idCurso,
                            date: cur.fechaInicio,
                            title: `Inicio de curso '${cur.titulo}'`,
                            desc: `El curso comienza el día ${moment(cur.fechaInicio).locale('es').format('DD-MMMM-YYYY')}`,
                            tipo: 'curso'
                        });
                        arr.push({
                            id: cur.idCurso,
                            date: cur.fechaFin,
                            title: `Fin curso ${cur.titulo}`,
                            desc: `El curso termina el día ${moment(cur.fechaFin).locale('es').format('DD-MMMM-YYYY')}`,
                            tipo: 'curso'
                        });

                        noti.push({
                            id: cur.idCurso,
                            date: cur.fechaInicio,
                            title: `Inicio de curso '${cur.titulo}'`,
                            desc: `El curso comienza el día ${moment(cur.fechaInicio).locale('es').format('DD-MMMM-YYYY')}`,
                            tipo: 'curso'
                        });
                        noti.push({
                            id: cur.idCurso,
                            date: cur.fechaFin,
                            title: `Fin curso ${cur.titulo}`,
                            desc: `El curso termina el día ${moment(cur.fechaFin).locale('es').format('DD-MMMM-YYYY')}`,
                            tipo: 'curso'
                        });
                    });

                    // Procesar notificaciones
                    data?.notificaciones.forEach((el) => {
                        if (el.slide == 1) {
                            // Si es slide, agregarlo SOLO a la lista de slide
                            listaNotificacionesSlide.push(el);
                        } else {
                            // Si no es slide, agregarlo a noti para la burbuja flotante
                            noti.push({
                                id: el.idnotificacion,
                                date: el.inicio,
                                fechaFin: el.fin,
                                title: el.anuncio,
                                tipo: 'mensaje',
                                desc: el.Descripcion,
                                periodo: el.periodo
                            });
                        }
                    });
                    const festivosCalendario = generarEventosFestivos(data?.festivos || []);
                    // Combinar eventos de cursos con festivos
                    const todosEventos = [...arr, ...festivosCalendario];

                    setCursos([...listaCursos]);
                    setAvisos([...todosEventos]); // Ahora incluye festivos
                    setNotificaciones([...noti]);
                    setNotificacionesSlide([...listaNotificacionesSlide]);
                },
                {
                    idColaborador: usuario.idColaborador,
                    idGrupo: usuario.idGrupo,
                    option,
                    idContrato: usuario.idcontrato,
                    depto: usuario.depto,
                    idcrm: idcrm
                }
            );
        }
    }, [usuario]);

    // Filtrado de cursos según el filtro seleccionado
    let cursosFiltrados = cursos;
    if (cursoFiltro === 0) {
        cursosFiltrados = cursos.filter((x) => x.numCalif == 0 && x.isAprobado == 0);
    } else if (cursoFiltro === 2) {
        cursosFiltrados = cursos.filter((x) => x.isAprobado == 0 && x.numCalif > 0);
    } else if (cursoFiltro === 1) {
        cursosFiltrados = cursos.filter((x) => x.isAprobado == 1);
    }

    return (
        <>
            <div className={classes.principal}>
                <MainCard>
                    <Grid container spacing={1} alignItems="center">
                        {/* Perfil y datos usuario */}
                        {!esIncognito && (
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Paper
                                    style={{
                                        width: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start',
                                        padding: '10px',
                                        color: '#b6a268',
                                        border: 'solid 1px #b6a268',
                                        borderRadius: '30px'
                                    }}
                                >
                                    <Avatar
                                        sx={{
                                            ...theme.typography.mediumAvatar,
                                            cursor: 'pointer',
                                            width: 50,
                                            height: 50
                                        }}
                                        aria-haspopup="true"
                                        color="inherit"
                                    >
                                        {context?.login?.usuario?.foto ? (
                                            <img alt="fotoPerfil" src={context?.login?.usuario?.foto} width={50} height={50} />
                                        ) : (
                                            <IconUser />
                                        )}
                                    </Avatar>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            color: '#b6a268'
                                        }}
                                    >
                                        <Stack>
                                            <Stack alignItems="left">
                                                <Typography variant="title" sx={{ color: '#b6a268', padding: '5px' }}>
                                                    {`${context.login?.usuario?.nombre}`}
                                                </Typography>
                                            </Stack>
                                        </Stack>
                                        <Stack>
                                            <IconButton
                                                sx={{ color: '#b6a268' }}
                                                variant="contained"
                                                aria-controls="simple-menu"
                                                aria-haspopup="true"
                                                aria-describedby={id}
                                                onClick={handleClick}
                                                component="span"
                                            >
                                                {open == true ? <ChevronLeft /> : <ChevronRight />}
                                            </IconButton>
                                        </Stack>
                                    </div>
                                </Paper>
                                <Popper Popper id={id} open={open} anchorEl={anchorEl} placement="right">
                                    <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                                        <Box sx={{ p: 2 }}>
                                            <Stack>
                                                <Stack direction="row" spacing={0.5} alignItems="center">
                                                    <Typography variant="h4">{`${context.login?.usuario?.nombre} (${context.login?.usuario?.nrol})`}</Typography>
                                                </Stack>
                                                <Typography variant="subtitle2">{context.login?.usuario?.email}</Typography>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <Typography variant="bodyInfo">{context.login?.usuario?.sede}</Typography>
                                                    <Typography variant="bodyInfo">{context.login?.usuario?.idcontrato}</Typography>
                                                </Box>
                                            </Stack>
                                        </Box>
                                    </MainCard>
                                </Popper>
                            </Grid>
                        )}

                        <Grid container spacing={2} alignItems="stretch">
                            {/* Filtros de cursos */}
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <ItemCarousel cursos={cursosFiltrados} selectCurso={selectCurso} />
                                <FiltrosEstadoCursos cursos={cursos} cursoFiltro={cursoFiltro} setCursoFiltro={setCursoFiltro} />
                            </Grid>

                            {/* Calendario y avisos */}
                            {!esIncognito && (
                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                    <Typography variant="title" sx={{ color: '#b6a268', padding: '5px' }}>
                                        CALENDARIO
                                    </Typography>
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        sx={{ backgroundColor: '#E0F7FA', color: '#000000', borderRadius: '30px', p: 2 }}
                                    >
                                        <Calendario eventos={avisos} accion={abrirMensajeCalendario} />
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>

                        {/* NOTIFICACIONES Y CONTACTO */}
                        <Grid container spacing={2} sx={{ mt: 2 }}>
                            {/* NOTIFICACIONES SLIDE */}
                            <Grid item xs={12} sm={12} md={8} lg={8}>
                                <NotificacionesCarousel
                                    notificaciones={notificacionesSlide}
                                    usuario={usuario}
                                    onSelectNotificacion={(notif) => {
                                        abrirMensajeCalendario({
                                            fecha: notif.fecha_inicio || notif.inicio,
                                            titulo: notif.anuncio || notif.Titulo
                                        });
                                    }}
                                />
                            </Grid>

                            {/* Contacto */}
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Contacto infoCotac={usuario} />
                            </Grid>
                        </Grid>
                    </Grid>
                </MainCard>
            </div>

            {/* Burbuja de notificaciones - solo notificaciones NO slide */}
            <FloatingOverlay notificaciones={notificaciones} showNotificaciones={!esIncognito} showChatBot={!esIncognito} />

            <ModalGeneral
                open={modal.open}
                titulo={modal.titulo}
                ContenidoMensaje={modal.mensaje}
                width="sm"
                acciones={
                    <Button onClick={cerrarModal} className={classes.btnCancelar}>
                        Cerrar
                    </Button>
                }
            >
                {modal.componente && <modal.componente {...modal.props} />}
            </ModalGeneral>
        </>
    );
};

export default InicioV2;
